/**
 * Aura AGM (MULTIPLE shareholders) preset (my_preset / sg / aura / agm-multi) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = My Preset 에서 온 AGM 선택 중 **multiple (shareholders)** 업무.
 *   priority 56 (sole Member agm 55 보다 높게 — "multiple" AGM 은 이 패널이 우선 잡히게).
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraAgmMultiPanel from './components/PreSetAuraAgmMultiPanel.vue';
import { auraAgmMultiFlow } from './chatflows/auraAgmMultiFlow';

export { default as PreSetAuraAgmMultiPanel } from './components/PreSetAuraAgmMultiPanel.vue';
export { auraAgmMultiFlow } from './chatflows/auraAgmMultiFlow';

/** 공통코드 — Aura AGM (Multiple) 전용 코드가 있으면 채운다(선택). */
export const AURA_AGM_MULTI_TASK_CODES: string[] = ['CAU003'];

export function matchesAuraAgmMulti(sel: PreSetSelection): boolean {
  // 코드 전용 매칭(CAU003). 이름 fallback 제거 — 고객사 접두어 코드가 유일 라우팅 키.
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_AGM_MULTI_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraAgmMultiPreset(): void {
  registerChatFlow(auraAgmMultiFlow);
  registerPanel({
    id: 'aura-agm-multi',
    priority: 56,
    match: (sel) => matchesAuraAgmMulti(sel),
    component: PreSetAuraAgmMultiPanel,
    meta: { docType: 'SG_AGM_MULTI_PRE', studio: true },
  });
}

registerAuraAgmMultiPreset();
